import type { UniversalModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import PaddingModifierComponent from "./base/PaddingModifier";
import TextColorModifierComponent from "./base/TextColorModifier";
import ModifierLayout from "./ModifierLayout";
import { useDefaultSelectedElementDesignation } from "./store/ModifiersStoreContext";

interface IconModifierBlockProps {
  onModifiersValueChange: (
    modifiers: UniversalModifierValue[],
    stableElementId: string,
  ) => void;
}

const IconModifierBlock: React.FC<IconModifierBlockProps> = ({
  onModifiersValueChange,
}) => {
  const defaultDesignation = useDefaultSelectedElementDesignation();

  if (!defaultDesignation) {
    return null;
  }

  const sections = [
    {
      rows: [
        {
          title: "Color",
          component: (
            <TextColorModifierComponent
              onChange={(modifiers) => {
                return onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Padding",
          component: (
            <PaddingModifierComponent
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
      ],
    },
  ];

  return (
    <ModifierLayout
      sections={sections}
      onModifiersValueChange={onModifiersValueChange}
    />
  );
};

export default IconModifierBlock;
